import queryString from 'query-string';
import { ACTIONS } from '../Constants';
import { VerbFetch } from '../VerbFetch';

export const postNotes = (params) => {
    const { pathsContext, ...rest } = params;
    const fetchOptions = {
        method: 'POST',
        body: rest
    };
    return (dispatch) =>
        VerbFetch(`${pathsContext.serverUrl}/notes`, fetchOptions).then((body) => {
            dispatch({
                type: ACTIONS.POST_NOTES,
                payload: { note: body }
            });
            return body;
        });
};

export const getManyNotes = (params) => {
    const { pathsContext, ...rest } = params;
    let newQuery;
    if (rest && Array.isArray(rest.parentId)) {
        newQuery = `parentId=${rest.userTrackId.join(',')}`;
        newQuery += `&parentType=${rest.parentType}`;
    } else {
        newQuery = queryString.stringify(rest);
    }
    return (dispatch) => {
        const url = `${pathsContext.serverUrl}/notes?${newQuery}`;
        return VerbFetch(url).then((body) => {
            dispatch({
                type: ACTIONS.GET_NOTES,
                payload: { notes: body }
            });
            return body;
        });
    };
};
